module.exports = __webpack_public_path__ + "media/images/icons/sports-slider-arrow-left-5709d89223aa6b10033c289daedcf1ae.svg";